import PouchDB from 'pouchdb-browser';
// import MemoryAdapter from 'pouchdb-adapter-memory';
import IndexAdapter from 'pouchdb-find';
// import idbAdapter from 'pouchdb-adapter-indexeddb';

PouchDB.plugin(IndexAdapter);
// PouchDB.plugin(idbAdapter);

export type Ts<T> = { [id in string]: T };
export interface DBDoc {
  id: string;
}
export class DB<T extends DBDoc> {
  private db: PouchDB.Database;
  private name: string;
  public async setup(data: T[]) {
    // console.log('db setup', this.name);
    await this.db.destroy();
    this.db = new PouchDB<T>(this.name);
    await this.db.bulkDocs(data);
    // console.log('db created', name, 'length ', data.length);
    // const info = await this.db.info();
    // console.log(info);
    return this;
  }

  public constructor(name: string) {
    this.db = new PouchDB<T>(name);
    this.name = name;
  }

  public createIndex(options: PouchDB.Find.CreateIndexOptions): void {
    this.db.createIndex(options);
  }

  public async getAllDocs(): Promise<Ts<T>> {
    const allDocs = await this.db.allDocs<T>({ include_docs: true });

    const docsObject: Ts<T> = {};

    allDocs.rows.forEach((e): void => {
      if (e.doc) {
        const id = e.doc.id;
        docsObject[id] = e.doc;
      }
    });

    return docsObject;
  }
  public async getDocFromId(id: string): Promise<T> {
    const { docs } = await this.db.find({ selector: { id: id } });

    const doc = docs[0] as unknown as T;

    return doc;
  }

  public async info() {
    const i = await this.db.info();
    // console.log(`--- db ${this.name} info`, i);
  }

  public async getDocByName(name: string): Promise<T> {
    const { docs } = await this.db.find({ selector: { name: name } });
    const doc = docs[0] as unknown as T;

    return doc;
  }

  public async getDocBySelector(selector: PouchDB.Find.Selector): Promise<T[]> {
    const { docs } = await this.db.find({ selector });
    // console.log(
    //   'db',
    //   this.name,
    //   ' selector:',
    //   selector,
    //   'info',
    //   this.db.info()
    // );

    return docs as unknown[] as T[];
  }

  public async createDoc(doc: T): Promise<PouchDB.Core.Response> {
    const res = await this.db.post({ ...doc });

    return res;
  }
}
